import axios from '@/plugins/axios';
import ErrorHandle from '@/helpers/errors/errorHandle';
import enumerateArray from '@/helpers/enumerateArray';

const initialState = {
  list: [],
  currentPage: 1,
  lastPage: 1,
  perPage: 10,
};

const actions = {
  async fetchList({ commit }, params) {
    try {
      const token = localStorage.getItem('token') || '';
      const lang = localStorage.getItem('language') || '';
      const { data } = await axios.get('/employees', {
        headers: { Authorization: `Bearer ${token}`, Lang: lang },
        params,
      });

      const list = enumerateArray(
        data.data.items.items,
        data.data.items.currentPage,
        data.data.items.perPage,
      );

      commit('setList', list);
      commit('setCurrentPage', data.data.items.currentPage);
      commit('setLastPage', data.data.items.lastPage);
      commit('setPerPage', data.data.items.perPage);

      return data;
    } catch (error) {
      return ErrorHandle(error, this);
    }
  },

  async addNew(_, formData) {
    try {
      const token = localStorage.getItem('token') || '';
      const lang = localStorage.getItem('language') || '';
      await axios.post('/employees', formData, {
        headers: { Authorization: `Bearer ${token}`, Lang: lang },
      });

      return { success: true };
    } catch (error) {
      return { error: true };
    }
  },

  async updateItem(_, { id, params }) {
    try {
      const token = localStorage.getItem('token') || '';
      const lang = localStorage.getItem('language') || '';
      await axios.put(`/employees/${id}`, params, {
        headers: { Authorization: `Bearer ${token}`, Lang: lang },
      });

      return { success: true };
    } catch (error) {
      return { error: true };
    }
  },

  async deleteItem(_, id) {
    try {
      const token = localStorage.getItem('token') || '';
      const lang = localStorage.getItem('language') || '';
      await axios.delete(`/employees/${id}`, {
        headers: { Authorization: `Bearer ${token}`, Lang: lang },
      });

      return { success: true };
    } catch (error) {
      return { error: true };
    }
  },

  async restoreItem(_, id) {
    try {
      const token = localStorage.getItem('token') || '';
      const lang = localStorage.getItem('language') || '';
      await axios.get(`/employees/restore/${id}`, {
        headers: { Authorization: `Bearer ${token}`, Lang: lang },
      });

      return { success: true };
    } catch (error) {
      return { error: true };
    }
  },
};

const mutations = {
  setList(state, payload) {
    state.list = payload;
  },

  setCurrentPage(state, payload) {
    state.currentPage = payload;
  },

  setLastPage(state, payload) {
    state.lastPage = payload;
  },

  setPerPage(state, payload) {
    state.perPage = payload;
  },
};

export default {
  namespaced: true,
  state: initialState,
  actions,
  mutations,
};
